/*
 * File: Routes.js
 * Project: patient-portal
 *
 * Created by Nate Weber on 08/14/2020
 *
 * Copyright (c) 2020 MacPractice, Inc. All rights reserved.
 *
 * Description:
 */

import React from "react";
import { Route, Switch } from "react-router-dom";

import AppLayout from "components/AppLayout";
import AuthenticatedRoute from "components/AuthenticatedRoute";
import Login from "components/Login";

const Routes = () => {
  return (
    <Switch>
      {/* Unauthenticated Routes */}
      <Route path="/login" component={Login} />

      {/* Authenticated Routes */}
      <AuthenticatedRoute path="/" component={AppLayout} />
    </Switch>
  );
};

export default Routes;
